"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOC = void 0;
const tslib_1 = require("tslib");
/* eslint-disable no-restricted-syntax */
const _ = tslib_1.__importStar(require("underscore"));
/**
 * A very simple IOC
 * @class IOC
 */
class IOC {
    constructor(debugMode = false) {
        this.debugMode = debugMode;
        this.container = {};
        this.onRegisterCallbacks = {};
        // if more than one container will be created, this is useful for comparing or checking which one is being used
        this.id = _.random(0, 99999).toString();
        if (debugMode) {
            setTimeout(() => {
                let unresolvedReferences = "";
                _.each(this.onRegisterCallbacks, (fns, id) => {
                    if (!this.container[id]) {
                        if (unresolvedReferences !== "")
                            unresolvedReferences += ", ";
                        unresolvedReferences += id;
                    }
                });
                if (unresolvedReferences !== "")
                    console.error("[IOC] After 1s the following references could not be resolved : " + unresolvedReferences, this.id);
            }, 1000);
        }
    }
    static register(id, value, forceRegister = false) {
        return IOC.instance().register(id, value, forceRegister);
    }
    /**
     * Registers a service/factory
     *
     * @param {string} id The identifier of the service/factory
     * @param {object} value The instance/constructor of the service/factory
     * @param {boolean} forceRegister Already registered instances aren't overwritten by default, here you can force that
     */
    register(id, value, forceRegister = false) {
        if (this.container[id] && !forceRegister) {
            if (this.debugMode)
                console.debug(`[IOC] Ignoring re-registering of ${id} since there is already an instance!`, this.id);
            return this.get(id);
        }
        this.container[id] = value;
        if (this.debugMode)
            console.debug(`[IOC] registered Object with ID: ${id}, Type:${typeof value}`, this.id);
        if (this.onRegisterCallbacks[id]) {
            _.each(this.onRegisterCallbacks[id], (onRegisterCallback) => {
                onRegisterCallback.callback(value);
            });
            this.onRegisterCallbacks[id] = _.reject(this.onRegisterCallbacks[id], (onRegisterCallback) => onRegisterCallback.callOnlyOnce === true);
        }
        return value;
    }
    /**
     * Gets a service/factory by id
     *
     * @param {string} id The identifier of the service/factory to get
     * @return {object} The instance/constructor of the service/factory
     */
    get(id) {
        if (this.isRegistered(id))
            return this.container[id];
        else
            throw new Error(`Could not find an ioc instance for id : '${id}'!`);
    }
    /**
     * Gets a service/factory by id
     *
     * @param {string} id The identifier of the service/factory to get
     * @return {object} The instance/constructor of the service/factory
     */
    static get(id) {
        return IOC.instance().get(id);
    }
    /**
     * Checks for availability of a service/factory
     *
     * @param {string} id The identifier of the service/factory to get
     * @return {boolean} True if something is registered, otherwise false
     */
    isRegistered(id) {
        return this.container[id] !== undefined;
    }
    static isRegistered(id) {
        return IOC.instance().isRegistered(id);
    }
    static instance() {
        let root;
        if (typeof global !== "undefined")
            root = global;
        else if (typeof window !== "undefined")
            root = window;
        else
            throw new Error("no 'window' or 'global' object found!");
        if (root.smallstack_ioc === undefined)
            root.smallstack_ioc = new IOC();
        return root.smallstack_ioc;
    }
    onRegister(id, callback, callOnlyOnce = false) {
        if (this.isRegistered(id))
            callback(this.get(id));
        if (!this.onRegisterCallbacks[id])
            this.onRegisterCallbacks[id] = [];
        this.onRegisterCallbacks[id].push({ callback, callOnlyOnce });
    }
    static onRegister(id, callback, callOnlyOnce = false) {
        IOC.instance().onRegister(id, callback, callOnlyOnce);
    }
    getIOCID() {
        return this.id;
    }
    /**
     * Removes all registered instances
     */
    clear() {
        this.container = [];
    }
    static clear() {
        IOC.instance().clear();
    }
}
exports.IOC = IOC;
